const mediaItems = [
  {
    title: '《流浪地球3》先导预告',
    duration: '02:35',
    desc: '太阳危机再度升级，人类命运何去何从？国产科幻巅峰之作第三部震撼来袭。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20with%20massive%20spaceships%20and%20dramatic%20cosmic%20lighting%2C%20warm%20golden%20and%20dark%20tones%2C%20movie%20trailer%20atmosphere%2C%20grand%20scale&width=800&height=500&seq=media-01-97movie&orientation=landscape',
  },
  {
    title: '《长安十二时辰2》精彩片段',
    duration: '04:12',
    desc: '盛世长安暗潮涌动，张小敬再赴危局，带你重回那个惊心动魄的十二时辰。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20warm%20lantern%20lighting%2C%20Tang%20Dynasty%20aesthetic%2C%20dramatic%20cinematic%20atmosphere%2C%20historical%20epic%20mood&width=800&height=500&seq=media-02-97movie&orientation=landscape',
  },
  {
    title: '年度最佳动画《深海2》特辑',
    duration: '03:48',
    desc: '极致唯美的粒子水墨画风再度进化，深海世界的神秘面纱即将揭开。',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20underwater%20animation%20scene%20with%20ink%20wash%20particles%20and%20warm%20bioluminescent%20lighting%2C%20Chinese%20art%20style%2C%20dreamy%20cinematic%20mood&width=800&height=500&seq=media-03-97movie&orientation=landscape',
  },
  {
    title: '《破冰行动2》幕后花絮',
    duration: '05:20',
    desc: '真实案件改编，硬核缉毒行动再现，带你走进拍摄现场的紧张与热血。',
    img: 'https://readdy.ai/api/search-image?query=Crime%20drama%20cinematic%20scene%20with%20dark%20moody%20lighting%20and%20warm%20highlights%2C%20police%20operation%20atmosphere%2C%20tense%20realistic%20film%20style&width=800&height=500&seq=media-04-97movie&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精彩预告
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            热门影视预告片与精彩花絮抢先看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-white text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 rounded text-xs text-white font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}